/*--------------------------------------------------------------------------------------------
Program     :  MapandTrack.js
Description :  Main program for Map and Track Middle data process
Date        :  29/08/2024 
Created By  :  Fode/Jelbin
---------------------------------------------------------------------------------------------
TicketNo         Author             Date               ChangeDesc
---------------------------------------------------------------------------------------------
29082024        - Fode/Jelbin     -  29/08/2024        Created
---------------------------------------------------------------------------------------------*/
import React, { useState, useRef, useEffect, useMemo, useCallback } from "react";
import TopBar from './TopBar';
import LeftSidebar from './LeftSidebar';
import RightSidebar from './RightSidebar';
import CollapsibleSidebar from './CollapsibleSidebar';
import CalendarView from './CalendarView';
import { GoogleMap, useLoadScript, LoadScript, OverlayView, Polyline, useGoogleMap, MarkerClusterer, Marker } from "@react-google-maps/api";
import {
    ToggleButtonGroup, ToggleButton, Table, TableBody, TableCell,
    TableRow, Box, TableHead, IconButton, Typography, FormLabel
} from '@mui/material';
import Switch from '@mui/material/Switch';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import InputLabel from "@mui/material/InputLabel";
import StarIcon from '@mui/icons-material/Star';
import DeleteIcon from '@mui/icons-material/Delete';
import ClearIcon from '@mui/icons-material/Clear';
import TimeCalculationService from '../service/TimeCalculationService';
import { useMapTrackInfo } from "../context/Maptrackcontext";
import { EditorState, convertToRaw } from 'draft-js';
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { imageUploadCallback } from '../service/HelperFunctions';
import { useSnackbar } from "notistack";
import PriorityWebSDKService from "../service/PriorityWebSDKService";
import MainService from "../service/MainService";
import TaskDialog from './TaskDialog';
import NightShelterIcon from '@mui/icons-material/NightShelter';
import PoiwarningDialog from "./PoiwarningDialog";
import HolidayDialog from "./HolidayDialog";
import HolidayWrngDialog from './HolidayWrngDialog';
import CircularProgress from '@mui/material/CircularProgress';


// Function to get the current week's date range (Monday to Sunday)
const getCurrentWeekRange = () => {
    const now = new Date();
    const currentDay = now.getDay();
    const diff = now.getDate() - currentDay + (currentDay === 0 ? -6 : 1);

    const monday = new Date(now);
    monday.setDate(diff);

    const sunday = new Date(now);
    sunday.setDate(diff + 6);

    const formatDate = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    return {
        start: formatDate(monday),
        end: formatDate(sunday)
    };
};

const createCustomMarker = (color, label, popupFields, switchChecked, isDetail,
    detail, handleDlgOpen, travelerData, handleDlgPOIOpen, messageFields, sourceIndex,
    visibility, selectedtraveler, headerindex, mapVisibilityDate, ZDATERANGE, editablefield,
    tableUniqueName, subformName, mainFormName, cordinateType) => {

    if (visibility === 'hidden') {
        return null;
    }

    const handleClick = () => {

        if (isDetail) {
            handleDlgOpen(detail, messageFields, sourceIndex, selectedtraveler, headerindex,
                editablefield, tableUniqueName, subformName, mainFormName);
        }
    };

    const handleUserClick = () => {

        if (travelerData) {
            handleDlgPOIOpen(travelerData, sourceIndex, mapVisibilityDate, ZDATERANGE);
        }
    }

    const nameswithpopupY = popupFields.filter(item => item.POPUP === "Y").map(item => item.NAME);
    if (detail !== null && detail !== undefined) {
        var detailArray = [detail]; // convert detail to array
    }

    if (isDetail === false) {
        var travelerDataArray = [travelerData]; // convert travelerData to array
    }

    const opacity = visibility === 'blur' ? 0.7 : 1;
    const filter = visibility === 'blur' ? 'blur(2px)' : 'none';

    return (
        <div style={{ position: 'relative', width: 0, height: 0 }}>
            {switchChecked && (
                <div style={{
                    position: 'absolute',
                    top: '-70px',
                    left: '-55px',
                    width: '120px',
                    textAlign: 'center',
                    opacity: opacity,
                    filter: filter
                }}>
                    <div style={{
                        background: 'orange',
                        color: 'white',
                        padding: '10px',
                        borderRadius: '10px',
                        fontWeight: 'bold',
                        fontSize: '12px',
                        position: 'relative'
                    }}>
                        {/* {time} {name} */}
                        {detailArray !== null && detailArray !== undefined ?
                            detailArray.map((task, index) => (
                                <div key={index}>
                                    {nameswithpopupY.map((field) =>
                                        task[field] ? (
                                            <div key={field}>
                                                <strong style={{ fontSize: '0.9em' }}></strong> {task[field]}
                                            </div>
                                        ) : null
                                    )}
                                </div>
                            ))
                            : <></>}
                        {isDetail === false ?
                            travelerDataArray.map((task, index) => (
                                <div key={index}>
                                    <strong style={{ fontSize: '0.9em' }}></strong> {task[selectedtraveler]}
                                </div>
                            ))
                            : <></>}
                        <div style={{
                            content: '""',
                            position: 'absolute',
                            bottom: '-10px',
                            left: '50%',
                            marginLeft: '-10px',
                            borderWidth: '10px 10px 0',
                            borderStyle: 'solid',
                            borderColor: 'orange transparent transparent transparent'
                        }} />
                    </div>
                </div>
            )}
            <svg xmlns="http://www.w3.org/2000/svg"
                viewBox={isDetail ? "0 0 20 20" : "0 0 30 30"}
                width="30" height="36"
                style={{
                    position: 'absolute',
                    left: '-18px',
                    top: '-12px',
                    opacity: opacity,
                    filter: filter
                }}>
                {isDetail ? (
                    <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"
                        fill={color} stroke="black" strokeWidth="1" onClick={handleClick} />
                ) : (
                    cordinateType === "BOTH" ?
                        <NightShelterIcon
                            style={{
                                color: color,
                                fontSize: 32,
                                position: 'absolute',
                                left: '-18px',
                                top: '-18px',
                                stroke: "black",
                                strokeWidth: "1"
                            }}
                            onClick={handleUserClick}
                        />
                        :
                        <circle cx="15" cy="15" r="12" fill={color} stroke="black" strokeWidth="2" onClick={handleUserClick} />
                )}
            </svg>
        </div>
    );
};

const Mapandtrack = () => {
    const [dateRange, setDateRange] = useState(getCurrentWeekRange());
    const [viewMode, setViewMode] = useState('map');
    //const [combinedData, setCombinedData] = useState([]);
    const [selectedtraveler, setSelectedTraveler] = useState("");
    const [selectedSourceMain, setSelectedSourceMain] = useState("");
    const [switchChecked, setswitchChecked] = useState(false);
    const [mapVisibility, setMapVisibility] = useState({});
    const [dayCapacityValue, setdayCapacityValue] = useState("");
    const [messageFields, setmessageFields] = useState([]);
    const [popupFields, setpopupFields] = useState([]);
    const [headerIndexval, setHeaderIndexVal] = useState(0);
    const [selectedUKey, setSelectedUKey] = useState("");
    const [ZDATERANGE, setZDATERANGE] = useState('');
    const googleMapRef = useRef(null);
    const [leftSidebarOpen, setLeftSidebarOpen] = useState(true);
    const [rightSidebarOpen, setRightSidebarOpen] = useState(true);
    const [deletePOI, setdeletePOI] = useState(false);
    const [assignPOI, setAssignPOI] = useState(false);
    const [durationFields, setdurationFields] = useState([]);
    const [mapVisibilityDate, setMapVisibilityDate] = useState("");
    const [tableUniqueName, settableUniqueName] = useState("");
    const [fieldPOIsave, setfieldPOIsave] = useState("");
    const [startTimeField, setstartTimeField] = useState("")
    const [endTimeField, setendTimeField] = useState("")
    var editorState = EditorState.createEmpty()
    const [description, setDescription] = useState(editorState);
    const [fielduserstartTime, setfielduserstartTime] = useState("")
    const [tskTravelTimeField, setTskTravelTimeField] = useState("")
    const [fixschedulefield, setfixschedulefield] = useState("")
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [selectedSourceMapname, setSelectedSourceMapname] = useState("")
    const [editablefield, seteditablefield] = useState([])
    const [saveType, setSaveType] = useState("")
    const [chooseOptions, setChooseOptions] = useState([]);
    const [onlyPOIChanged, setOnlyPOIChanged] = useState(false);
    const [changeChooseData, setchangeChooseData] = useState(false);
    const [subformName, setsubformName] = useState("");
    const [editNote, setEditNote] = useState(false);
    const [mainFormName, setMainFormName] = useState("");
    const [participantsData, setParticipantsData] = useState([]);
    const [statuscolorField, setstatuscolorField] = useState("");
    const [showPOIDialog, setShowPOIDialog] = useState(false);
    const [showHolidayDialog, setShowHolidayDialog] = useState(false);
    const [showHolidayWrngDialog, setShowHolidayWrngDialog] = useState(false);

    const { dataModified, setDataModified, selectedChooseData, setSelectedChooseData,
        combinedData, setCombinedData, timeATPOI, dlgPOIopen, setdlgPOIopen, note, setNote,
        dlgopen, setdlgOpen, messageData, setMessageData, noteData, setnoteData,
        travelerName, setravelerName, POIExist, setPOIExist, reassignMapData, setReassignMapData,
        sourceIndexVal, setSourceIndexVal, oldSourceindex, setoldSourceindex, participantsFields,
        noteLocalSave, setNoteLocalSave, tableUniqueValue, settableUniqueValue, poiData, setPOIData,
        mergeparticipantFields, envFileData, startsave, setStartsave, selectedTaskVal,
        setselectedTaskVal, taskClicked, settaskClicked, selectedCalenderTaskVal,
        setselectedCalenderTaskVal, setOpenCalender, setParticipantTaskTime, holidayPayload,
        selectedCalenderTaskDate, fielduserHide, setfielduserHide, finalTravelTimeData,
        setFinalTravelTimeData, userOrPOIchange, setUserOrPOIchange, onlyuserChange,
        setonlyUserChange, savedata, travelTimeLoader, travelbuttonEnable,
        setTravelbuttonEnable, setSavebuttonEnable, agentColor, setagentColor } = useMapTrackInfo();


    const toggleLeftSidebar = () => setLeftSidebarOpen(!leftSidebarOpen);
    const toggleRightSidebar = () => setRightSidebarOpen(!rightSidebarOpen);


    const LoadingOverlay = () => (
        <div style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(255, 255, 255, 0.7)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 1000,
            cursor: 'not-allowed'
        }}>
            <div style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: '10px',
                backgroundColor: 'white',
                padding: '20px',
                borderRadius: '8px',
                boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
            }}>
                <CircularProgress size={40} />
                {savedata ? <div>Saving Data.Please Wait...</div> :
                    <div>Calculating Travel Time.Please Wait...</div>}
            </div>
        </div>
    );

    // Add a tiny offset based on index to separate markers at the same location
    // This will be invisible to users but prevents clustering issues

    const addOffset = (coordinates, index) => {
        if (!coordinates) return coordinates;

        const maxSteps = 10;            // maximum distinct offset patterns     
        const step = index % maxSteps;  // wrap around so it repeats every 10
        const offset = 0.00001;        // about 1 meter

        const lat = coordinates.lat + (Math.sin(step) * offset);
        const lng = coordinates.lng + (Math.cos(step) * offset);

        return {
            lat: +lat.toFixed(7), // get first 7 digit
            lng: +lng.toFixed(7)
        };
    };

    const handleTaskMove = useCallback((task, sourceTraveler, destTraveler, sourceDate, destDate) => {
        setCombinedData(prevData => {
            return prevData.map(traveler => {
                if (traveler[selectedtraveler] === sourceTraveler) {
                    if (sourceTraveler === destTraveler) {
                        // If it's the same traveler, just update the task's date
                        return {
                            ...traveler,
                            details: traveler.details.map(t =>
                                isEqual(t, task)
                                    ? { ...t, [ZDATERANGE]: new Date(destDate).toISOString().split('T')[0] + 'T00:00:00+01:00' }
                                    : t
                            )
                        };
                    } else {
                        // If it's a different traveler, remove the task
                        return {
                            ...traveler,
                            details: traveler.details.filter(t => !isEqual(t, task))
                        };
                    }
                }
                if (traveler[selectedtraveler] === destTraveler && sourceTraveler !== destTraveler) {
                    // Add the task to the destination traveler
                    const updatedTask = {
                        ...task,
                        [ZDATERANGE]: new Date(destDate).toISOString().split('T')[0] + 'T00:00:00+01:00',
                        color: traveler.color, // Change the color to destination color
                        [selectedtraveler]: traveler[selectedtraveler] // Change the user to destination user
                    };
                    return {
                        ...traveler,
                        details: [...traveler.details, updatedTask]
                    };
                }

                return traveler;
            });
        });
    }, [selectedtraveler, ZDATERANGE]);

    // Helper function to compare objects
    const isEqual = (obj1, obj2) => {
        return JSON.stringify(obj1) === JSON.stringify(obj2);
    };

    const containerStyle = {
        width: "100%",
        height: "100%",
        border: "2px solid #1976D2",
        boxSizing: "border-box",
        margin: "0 auto",
        position: "relative",
    };

    const apiKey = envFileData.GOOGLE_API; //process.env.REACT_APP_API_KEY;

    const handlePOIDataChange = useCallback((newPOIData) => {
        setPOIData(newPOIData);
    }, []);

    const handleswitchChange = (event) => {
        setswitchChecked(event.target.checked);
    };

    const center = useMemo(() => ({
        lat: 51.509865,
        lng: -0.118092,
    }), []);

    const handleViewModeChange = useCallback((event, newViewMode) => {
        if (newViewMode !== null) {
            setViewMode(newViewMode);
        }
        if (newViewMode === "calendar") {
            setOpenCalender(true);
        }
        else {
            setOpenCalender(false);
        }
        setselectedTaskVal({});
        setselectedCalenderTaskVal({});
        settaskClicked(false);
    }, []);


    const handleVisibilityChange = useCallback((newVisibility) => {
        setMapVisibility(newVisibility);
        const visibleDateValue = Object.keys(newVisibility).find(date => newVisibility[date] === "visible");
        setMapVisibilityDate(visibleDateValue);
    }, []);

    // Create the array for the co-ordiantes

    const getVisibleRouteCoordinates = useCallback((traveler) => {
        if (!traveler || !traveler.coordinates) return [];

        const coordinatesToUse = TimeCalculationService.getValidCoordinates(traveler, mapVisibilityDate);
        let visibleCoords = [];
        if (coordinatesToUse.type !== 'END') {
            visibleCoords.push(coordinatesToUse.coordinates);
        }
        else {
            visibleCoords.push(traveler.coordinates);
        }
        // Process regular tasks
        if (traveler.details && Array.isArray(traveler.details)) {
            traveler.details.forEach(detail => {
                if (detail && detail[ZDATERANGE]) {
                    const originalDate = new Date(detail[ZDATERANGE]);
                    const utcDate = new Date(originalDate.getTime() - originalDate.getTimezoneOffset() * 60000);
                    const detailDate = utcDate.toISOString().split('T')[0];
                    const visibility = mapVisibility[detailDate] || 'visible';

                    if (visibility === 'visible') {
                        // Handle POIs associated with the task
                        if (detail.pointsOfInterest?.length) {
                            detail.pointsOfInterest.forEach(poi => {
                                if (poi?.coordinates) {
                                    visibleCoords.push(poi.coordinates);
                                }
                            });
                        }
                        // Add task coordinates
                        if (detail.coordinates) {
                            visibleCoords.push(detail.coordinates);
                        }
                    }
                }
            });
        }

        // Process route-level POIs for the selected date
        if (traveler.pointsOfInterest?.length) {
            traveler.pointsOfInterest.forEach(poi => {
                if (poi?.coordinates && poi.POIASSIGNDATE === mapVisibilityDate) {
                    visibleCoords.push(poi.coordinates);
                }
            });
        }

        // Add final return point
        let coordinatesToUseFinal = {};
        if (coordinatesToUse.type !== 'START') {
            coordinatesToUseFinal = coordinatesToUse.coordinates;
        }
        else {
            coordinatesToUseFinal = traveler.coordinates;
        }

        visibleCoords.push(coordinatesToUseFinal);

        // Filter and validate coordinates
        return visibleCoords.filter(coord =>
            coord &&
            typeof coord.lat === 'number' &&
            typeof coord.lng === 'number'
        );
    }, [ZDATERANGE, mapVisibility]);


    const handleDlgOpen = useCallback((detail, messageFields, sourceIndex, selectedtraveler,
        headerindex, editablefield, tableUniqueName, subformName, mainFormName) => {
        setdeletePOI(false);
        setDataModified(false);
        setravelerName(detail[selectedtraveler]);
        setHeaderIndexVal(headerindex);
        setSourceIndexVal(sourceIndex);
        setselectedTaskVal(detail);
        settaskClicked(true);
        // setDataModified(false);
        settableUniqueValue(detail[tableUniqueName]);
        setagentColor(detail.color)

        if (detail.pointsOfInterest !== undefined) {
            setPOIExist(true);
        }

        const filteredA1 = {};
        messageFields.forEach((key) => {
            if (key.NAME in detail) {
                filteredA1[key.TITLE] = detail[key.NAME];
            }
        });
        const editablevalue = {};
        editablefield.forEach((key) => {
            if (key.NAME in detail) {
                editablevalue[key.NAME] = detail[key.NAME];
            }
        });

        // Calling service to get the Note data for on the selected Task
        if (subformName) {
            const ZrecordUniqueVal = detail[tableUniqueName];
            MainService.getNoteData(mainFormName, subformName, ZrecordUniqueVal)
                .then((noteresponse) => {
                    setnoteData(noteresponse.data.TEXT);
                })
                .catch((err) => console.error("Error fetching POI data:", err));
        }
        setSelectedChooseData(editablevalue);
        setMessageData(filteredA1);
        setReassignMapData(detail);
        setoldSourceindex(sourceIndex);
        setdlgOpen(true);
    }, []);

    const handleDlgClose = useCallback(() => {
        setdlgOpen(false);
        setStartsave(false);
        setdlgPOIopen(false);
        setMessageData(null);
        setSelectedUKey("");
        setPOIExist(false);
        setSelectedChooseData([]);
        // setDataModified(false);
        setEditNote(false);
        setnoteData();
        setoldSourceindex(0);
        setSourceIndexVal(0);
        settableUniqueValue("");
    }, []);


    const handleDlgPOIOpen = useCallback((travelerData, sourceIndex, mapVisibilityDate, ZDATERANGE) => {
        setReassignMapData(travelerData);
        setoldSourceindex(sourceIndex);
        setdeletePOI(false);
        setagentColor(travelerData.color);
        const travelfilter = travelerData.details.filter((data) => data[ZDATERANGE].startsWith(mapVisibilityDate));
        if (travelfilter.length !== 0) {
            setdlgPOIopen(true);
        }

        if (travelerData.pointsOfInterest !== undefined) {
            setPOIExist(true);
        }
    }, []);

    const handleDlgPOIClose = useCallback(() => {
        setdlgPOIopen(false);
        setPOIExist(false);
    }, []);

    const ArrowPolyline = ({ traveler, color }) => {
        const map = useGoogleMap();

        if (!map || !traveler) return null;

        const arrowSymbol = {
            path: window.google.maps.SymbolPath.FORWARD_CLOSED_ARROW
        };

        const visibleRouteCoordinates = getVisibleRouteCoordinates(traveler);

        if (visibleRouteCoordinates.length >= 2) {
            return (
                <Polyline
                    path={visibleRouteCoordinates}
                    options={{
                        strokeColor: color,
                        strokeOpacity: 0.8,
                        strokeWeight: 2,
                        icons: [{
                            icon: arrowSymbol,
                            offset: '100%',
                            repeat: '50px'
                        }]
                    }}
                />
            );
        }

        return null;
    };

    const POIIcon = ({ name, indexval }) => (
        <div style={{ position: 'relative' }}>
            <StarIcon
                style={{
                    color: '#2A2A2A',
                    fontSize: 36,
                    position: 'absolute',
                    left: '-18px',
                    top: '-18px',
                }}
            />
            {name && (
                <div style={{
                    position: 'absolute',
                    top: '-40px',
                    left: '-50px',
                    width: '100px',
                    textAlign: 'center',
                    background: 'white',
                    padding: '2px',
                    borderRadius: '2px',
                    fontSize: '10px',
                    boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
                }}>
                    {name}
                </div>
            )}
        </div>
    );
    const memoizedGoogleMarkers = useMemo(() => {
        let globalIndex = 0;
        // Extract all task markers that should be visible for clustering
        const clusterableMarkers = combinedData.flatMap((traveler, tIndex) =>
            traveler.details ? traveler.details.map((detail, dIndex) => {
                if (detail[ZDATERANGE] && detail.coordinates) {
                    const originalDate = new Date(detail[ZDATERANGE]);
                    const utcDate = new Date(originalDate.getTime() - originalDate.getTimezoneOffset() * 60000);
                    const detailDate = utcDate.toISOString().split('T')[0];
                    const visibility = mapVisibility[detailDate] || 'visible';
                    // Only include visible markers
                    if (visibility !== 'hidden') {
                        // Apply small offset to prevent exact overlapping
                        const offsetPosition = addOffset(detail.coordinates, globalIndex++);

                        return {
                            id: `${tIndex}-${dIndex}`,
                            position: offsetPosition, // Use the offset position
                            originalPosition: detail.coordinates, // Keep original position for reference
                            color: detail.color,
                            detail: detail,
                            visibility: visibility
                        };
                    }
                }
                return null;
            }).filter(Boolean) : []
        );

        return (
            <>
                {combinedData.map((traveler, index) => {
                    if (traveler[fielduserHide] === null || traveler[fielduserHide] === undefined) {
                        const travelerField = traveler.TRAVELLER || traveler.id || index.toString();
                        const coordinatesInfo = TimeCalculationService.getValidCoordinates(traveler, mapVisibilityDate);
                        return (
                            <React.Fragment key={traveler.id || index}>
                                {traveler.coordinates && (
                                    <>
                                        {/* If coordinatesInfo.type === 'START' → render only END marker using traveler.coordinates. */}
                                        {/* If coordinatesInfo.type === 'END' → render only START marker using traveler.coordinates. */}
                                        {(coordinatesInfo.type === 'START' || coordinatesInfo.type === 'END') && (
                                            <OverlayView
                                                position={traveler.coordinates}
                                                mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
                                            >
                                                {createCustomMarker(
                                                    traveler.color,
                                                    travelerField.toString(),
                                                    popupFields,
                                                    switchChecked,
                                                    false,
                                                    null,
                                                    null,
                                                    traveler,
                                                    handleDlgPOIOpen,
                                                    null,
                                                    index,
                                                    'visible',
                                                    selectedtraveler,
                                                    null,
                                                    mapVisibilityDate,
                                                    ZDATERANGE,
                                                    editablefield,
                                                    tableUniqueName,
                                                    subformName,
                                                    mainFormName,
                                                    coordinatesInfo.type === 'START' ? 'END' : 'START' // reverse the context
                                                )}
                                            </OverlayView>
                                        )}
                                        {/* If coordinatesInfo.type === 'BOTH' or 'DEFAULT' → render only the coordinatesInfo marker. */}
                                        {(coordinatesInfo.type === 'BOTH' || coordinatesInfo.type === 'DEFAULT') ? (
                                            <OverlayView
                                                position={coordinatesInfo.coordinates}
                                                mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
                                            >
                                                {createCustomMarker(
                                                    traveler.color,
                                                    travelerField.toString(),
                                                    popupFields,
                                                    switchChecked,
                                                    false,
                                                    null,
                                                    null,
                                                    traveler,
                                                    handleDlgPOIOpen,
                                                    null,
                                                    index,
                                                    'visible',
                                                    selectedtraveler,
                                                    null,
                                                    mapVisibilityDate,
                                                    ZDATERANGE,
                                                    editablefield,
                                                    tableUniqueName,
                                                    subformName,
                                                    mainFormName,
                                                    coordinatesInfo.type
                                                )}
                                            </OverlayView>
                                        ) : (
                                            <OverlayView
                                                position={coordinatesInfo.coordinates}
                                                mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
                                            >
                                                <NightShelterIcon
                                                    style={{
                                                        color: traveler.color,
                                                        fontSize: 32,
                                                        position: 'absolute',
                                                        left: '-18px',
                                                        top: '-18px',
                                                        stroke: "black",
                                                        strokeWidth: "1"
                                                    }}
                                                />
                                            </OverlayView>
                                        )}
                                    </>
                                )}
                                <ArrowPolyline
                                    traveler={traveler}
                                    color={traveler.color}
                                />
                            </React.Fragment>
                        );
                    } else {
                        return null;
                    }
                })}
                {/* Task markers with clustering -if the location is nearby-then marker will automatically cluster that task*/}
                {clusterableMarkers.length > 0 ? (
                    <MarkerClusterer
                        options={{
                            imagePath: 'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m',
                            gridSize: 60,
                            minimumClusterSize: 2,
                            maxZoom: 20
                        }}
                    >
                        {(clusterer) => (
                            <>
                                {clusterableMarkers.map((markerInfo) => (
                                    <Marker
                                        key={markerInfo.id}
                                        position={markerInfo.position}
                                        clusterer={clusterer}
                                        icon={{
                                            // Use a simple SVG icon here for better clustering
                                            path: 'M 12,2 C 8.13,2 5,5.13 5,9 c 0,5.25 7,13 7,13 0,0 7,-7.75 7,-13 0,-3.87 -3.13,-7 -7,-7 z M 12,11.5 C 10.62,11.5 9.5,10.38 9.5,9 9.5,7.62 10.62,6.5 12,6.5 c 1.38,0 2.5,1.12 2.5,2.5 0,1.38 -1.12,2.5 -2.5,2.5 z',
                                            fillColor: markerInfo.color,
                                            fillOpacity: markerInfo.visibility === 'blur' ? 0.7 : 1,
                                            strokeWeight: 1,
                                            strokeColor: '#000',
                                            scale: 1.2,
                                            anchor: new window.google.maps.Point(12, 17),
                                        }}
                                        opacity={markerInfo.visibility === 'blur' ? 0.7 : 1}
                                        onClick={() => {
                                            const [tIndex, dIndex] = markerInfo.id.split('-').map(Number);
                                            handleDlgOpen(
                                                markerInfo.detail,
                                                messageFields,
                                                dIndex,
                                                selectedtraveler,
                                                tIndex,
                                                editablefield,
                                                tableUniqueName,
                                                subformName,
                                                mainFormName
                                            );
                                        }}
                                    />
                                ))}
                            </>
                        )}
                    </MarkerClusterer>
                ) : null}

                {/* Display list of POI*/}
                {poiData.map((poi, index) => (
                    poi.coordinates && (
                        <OverlayView
                            key={`poi-${index}`}
                            position={poi.coordinates}
                            mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
                        >
                            <POIIcon
                                name={poi.UNKdata}
                                color='red'
                                indexval={index}
                            />
                        </OverlayView>
                    )
                ))}
            </>
        );
    }, [combinedData, switchChecked, mapVisibility, poiData, messageFields, handleDlgOpen, ZDATERANGE]);

    const renderGoogleMap = useCallback(() => (
        <GoogleMap
            mapContainerStyle={containerStyle}
            center={center}
            zoom={8}
            onLoad={map => {
                googleMapRef.current = map;
            }}
            options={{
                maxZoom: 30,
            }}
        >
            {memoizedGoogleMarkers}
        </GoogleMap>
    ), [center, memoizedGoogleMarkers]);


    const handleUserChange = (traveler, index) => {
        setravelerName(traveler);
        setHeaderIndexVal(index);
        setUserOrPOIchange(true);
        setonlyUserChange(true);
        setOnlyPOIChanged(false);
        if (viewMode === "calendar") {
            if ((selectedCalenderTaskVal[selectedtraveler]) !== traveler) {
                setDataModified(true);
            } else {
                setDataModified(false);
            }
        }
        else {
            if ((selectedTaskVal[selectedtraveler]) !== traveler) {
                setDataModified(true);
            } else {
                setDataModified(false);
            }
        }
    };


    const handlePOIDlgYes = () => {
        setShowPOIDialog(false);
        handleProcessDataReassign();
    };

    const handlePOIDlgNo = () => {
        setShowPOIDialog(false);
        setdlgOpen(false);
    };

    const handleHolidayYes = () => {
        setShowHolidayDialog(false);
        // setdlgOpen(false);
        handleProcessDataReassign(); // comment if block the assgnemt when user holiday
    }

    const handleHolidayWrngYes = () => {
        setShowHolidayWrngDialog(false);
    }

    // Function to reassign the task
    const handleDataReassign = async () => {
        // Check is the destination user is on Holiday or not
        var ztaskDate = "";
        if (viewMode === "calendar") {
            ztaskDate = selectedCalenderTaskDate;
        }
        else { // Map
            ztaskDate = mapVisibilityDate;
        }
        // Check the logic for user holiday 
        const isUserHoliday = TimeCalculationService.handlecheckisUserHoliday(holidayPayload,
            selectedtraveler, travelerName, ztaskDate);
        if (isUserHoliday) {
            setShowHolidayDialog(true);
        }
        else {
            // Logic to check for any POI exists with task
            if ((selectedTaskVal.pointsOfInterest !== undefined || selectedCalenderTaskVal.pointsOfInterest !== undefined) &&
                onlyuserChange && !onlyPOIChanged) {
                setShowPOIDialog(true);
            }
            else {
                if (onlyuserChange === true) {
                    return await handleProcessDataReassign();
                }
                else {
                    handleProcessDataReassign();
                }
            }
        }
    };

    const handleProcessDataReassign = async () => {
        setStartsave(true);
        try {
            var updatedReassignMapData = [];
            var updatedReassignMapDataFinal;
            let updatedCombinedPayload = JSON.parse(JSON.stringify(combinedData));
            // step1: Find source and destination agent indices
            const sourceAgentIndex = updatedCombinedPayload.findIndex(
                agent => agent[selectedtraveler] === reassignMapData[selectedtraveler]
            );
            const destAgentIndex = updatedCombinedPayload.findIndex(
                agent => agent[selectedtraveler] === travelerName
            );

            if (sourceAgentIndex === -1 || destAgentIndex === -1) {
                throw new Error('Source or destination agent not found');
            }
            if (userOrPOIchange) {
                setTravelbuttonEnable(true);
                setSavebuttonEnable(false);
                // step2: Update task with any editable field changes
                if (selectedChooseData.length !== "") {
                    for (const key in selectedChooseData) {
                        if (selectedChooseData.hasOwnProperty(key) && reassignMapData.hasOwnProperty(key)) {
                            reassignMapData[key] = selectedChooseData[key];
                        }
                    }
                    if (note) {
                        reassignMapData[subformName + "_SUBFORM"] = {
                            TEXT: note,
                            APPEND: true
                        };
                    }
                    else {
                        delete reassignMapData[subformName + "_SUBFORM"];
                    }
                    updatedReassignMapData = { ...reassignMapData, recordchange: true };
                } else {
                    updatedReassignMapData = { ...reassignMapData };
                }
                // step3: Update task with new agent details
                if (updatedReassignMapData[selectedtraveler] !== travelerName) {
                    updatedReassignMapData = {
                        ...updatedReassignMapData,
                        participantFinalTrvltime: [], // clear participantFinalTrvltime block
                        color: updatedCombinedPayload[destAgentIndex].color,
                        recordchange: true,
                        [selectedtraveler]: travelerName
                    };
                }
                updatedReassignMapDataFinal = updatedReassignMapData;
                // step4: Handle POI assignment if selected
                if (selectedUKey !== "") {
                    const selectedUKeyRecord = poiData.filter((unkitem) => unkitem.UNKdata === selectedUKey);
                    const isKeyExistInPOI = updatedReassignMapDataFinal.pointsOfInterest?.some(
                        (poi) => poi.UNKdata === selectedUKey
                    );
                    if (!isKeyExistInPOI) {
                        updatedReassignMapDataFinal = {
                            ...updatedReassignMapDataFinal,
                            recordchange: true,
                            pointsOfInterest: [
                                ...(updatedReassignMapDataFinal.pointsOfInterest || []),
                                ...selectedUKeyRecord
                            ]
                        };
                    }
                }
                // Step5:
                /* When Only POI reassign, the sourceAgentIndex and destAgentIndex is same.
                Do the travtimeTo calucation only for the POI added task& update the calcuated task back to CombinedData */
                if (onlyuserChange === false) {  // This means only POI changed // onlyPOIChanged && !onlyuserChange 
                    // Update the POI assigned task back to combineddata.
                    updatedCombinedPayload[destAgentIndex].details[sourceIndexVal] = updatedReassignMapDataFinal;
                }
                else {
                    // When Only user change or both user and POI change.
                    // Remove task from source agent
                    updatedCombinedPayload[sourceAgentIndex].details.splice(oldSourceindex, 1);
                    // Add task to destination agent
                    updatedCombinedPayload[destAgentIndex].details.push(updatedReassignMapDataFinal);
                }

                // Step8: Check and reassign POIs
                TimeCalculationService.reassignuserPOI(
                    updatedCombinedPayload,
                    ZDATERANGE,
                    mapVisibilityDate,
                    selectedtraveler
                );
                // Step9: Loop the payload and make totalTime: 0 if any agent.details.length = 0
                const updatedDataFinal = updatedCombinedPayload.map(agent => {
                    // Check if 'details' is empty
                    if (agent.details.length === 0) {
                        return {
                            ...agent,
                            totalTime: 0
                        };
                    }
                    return agent;
                });

                // Add/Remove the user participants with the task
                if (sourceAgentIndex !== destAgentIndex) {
                    const ZupdatedetailParticipants = TimeCalculationService.handleAddparticipants(updatedDataFinal, destAgentIndex, participantsFields,
                        reassignMapData[tableUniqueName], tableUniqueName);
                    updatedDataFinal[destAgentIndex].details = ZupdatedetailParticipants;
                }
                // Update state with new data
                setCombinedData(updatedDataFinal);
            } else {
                // Handle case where only editable fields are changed (no user/PO reassignment)
                const updatedCombinedPayload = combinedData.map((dataitem) => {
                    if (dataitem[selectedtraveler] === travelerName && selectedChooseData.length !== 0) {
                        if (dataitem.details && dataitem.details.length > 0) {
                            const detail = dataitem.details[sourceIndexVal];
                            if (detail) {
                                Object.keys(selectedChooseData).forEach((key) => {
                                    if (detail.hasOwnProperty(key)) {
                                        detail[key] = selectedChooseData[key];
                                    }
                                });
                                detail.recordchange = true;

                                // Logic  for Note localSave
                                setNoteLocalSave(prevNotes => {
                                    // Check if the UNIQUEID already exists
                                    const existingIndex = prevNotes.findIndex(noteval => noteval.UNIQUEID === tableUniqueValue);

                                    if (existingIndex !== -1) {
                                        // Update the existing record's NOTEVAL
                                        const updatedNotes = [...prevNotes];
                                        updatedNotes[existingIndex] = { UNIQUEID: tableUniqueValue, NOTEVAL: note };
                                        return updatedNotes;
                                    } else {
                                        //Add a new record if UNIQUEID doesn't exist
                                        return [...prevNotes, { UNIQUEID: tableUniqueValue, NOTEVAL: note }];
                                    }
                                });

                                if (note) {
                                    detail[subformName + "_SUBFORM"] = {
                                        TEXT: note,
                                        APPEND: true
                                    };
                                }
                            }
                        }
                    }
                    return dataitem;
                });
                setCombinedData(updatedCombinedPayload);
                // if (onlyuserChange === true) {
                //     return updatedCombinedPayload;
                // }
                if (!travelbuttonEnable) {
                    setSavebuttonEnable(true); //only editable fields are changed
                }
            }

            // After reassign ,Show  the warning message if any of the participant is on absent 
            // for the date under the destiantion user.
            for (const agentblock of updatedCombinedPayload) {
                if (agentblock[selectedtraveler] === travelerName) {

                    for (const participantblock of agentblock.ZCLA_TEAMMEMBERSR_SUBFORM) {
                        const isUserHoliday = TimeCalculationService.handlecheckisUserHoliday(
                            holidayPayload,
                            selectedtraveler,
                            participantblock[selectedtraveler],
                            viewMode === "calendar" ?
                                selectedCalenderTaskDate : mapVisibilityDate,
                        );
                        if (isUserHoliday) {
                            setShowHolidayWrngDialog(true);
                            break; // exits the inner loop
                        }
                    }
                    break; // exits the outer loop 
                }
            }
        } catch (error) {
            enqueueSnackbar(`Error reassigning task: ${error.message}`, {
                variant: 'error',
                autoHideDuration: 4000
            });
        } finally {
            // Reset all states
            setdlgOpen(false);
            setStartsave(false);
            setSelectedUKey("");
            setPOIExist(false);
            setUserOrPOIchange(false);
            setchangeChooseData(false);
            setNote("");
            setonlyUserChange(false);
            setOnlyPOIChanged(false);
            setEditNote(false);
            setdeletePOI(false);
        }
    }


    // Function to reassign the POI
    const handlePOIReassign = async () => {
        try {
            setDataModified(true);
            setAssignPOI(true);
            setTravelbuttonEnable(true);
            setSavebuttonEnable(false);
            const selectedPOIRecord = poiData.filter((unkitem) => unkitem.UNKdata === selectedUKey);
            const selectedPOIRecordData = selectedPOIRecord[0];

            // Add new field for the POI assign date
            const selectedPOIRecordDataUpdate = {
                ...selectedPOIRecordData,
                POIASSIGNDATE: mapVisibilityDate
            };

            // First update the combined data with POI changes
            const updatedCombinedData = combinedData.map((dataitem, index) => {
                if (index === oldSourceindex) {
                    const isKeyExistInPOI = dataitem.pointsOfInterest?.some(
                        (poi) => poi.UNKdata === selectedUKey &&
                            poi.POIASSIGNDATE === mapVisibilityDate
                    );

                    if (!isKeyExistInPOI && selectedUKey !== "") {
                        let updatedPointsOfInterest = reassignMapData.pointsOfInterest || [];
                        updatedPointsOfInterest = [...updatedPointsOfInterest, selectedPOIRecordDataUpdate];
                        return {
                            ...dataitem,
                            userPOIChange: true,
                            pointsOfInterest: updatedPointsOfInterest
                        };
                    } else {
                        return {
                            ...dataitem,
                            userPOIChange: true,
                            pointsOfInterest: reassignMapData.pointsOfInterest
                        };
                    }
                }
                return dataitem;
            });

            // Update the selected POI for the user with finalTravelTime record
            const updatedCombinedDataFinal = updatedCombinedData.map(cmbData => {
                if (cmbData[selectedtraveler] === reassignMapData[selectedtraveler] && cmbData.userPOIChange) {
                    const updatedFinalTravelTime = cmbData.finalTravelTime.map(travel => {
                        if (travel.TRAVELDATE.startsWith(mapVisibilityDate)) {
                            return { ...travel, USERPOI: selectedUKey };
                        }
                        return travel;
                    });
                    return { ...cmbData, finalTravelTime: updatedFinalTravelTime };
                }
                return cmbData;
            });
            // Update state with final data
            // setCombinedData(finalUpdatedCombinedData); JKB
            setCombinedData(updatedCombinedDataFinal);

            // Reset UI states
            setdlgPOIopen(false);
            setPOIExist(false);
            setSelectedUKey("");
            setSaveType("");
            setAssignPOI(false);
        } catch (error) {
            console.error('Error in handlePOIReassign:', error);
            // Handle error appropriately
        }
    };
    const handlePOIUKey = (event) => {
        setSelectedUKey(event.target.value);
        setUserOrPOIchange(true);
        setDataModified(true);
        setOnlyPOIChanged(true);
    }

    const handleChooseData = async (event, fieldName) => {
        const { value } = event.target;
        // Update the selectedChooseData object dynamically using the fieldName (field.NAME)
        setSelectedChooseData(prevState => ({
            ...prevState,
            [fieldName]: value // Use fieldName as key and value as the new selected value
        }));
        setchangeChooseData(true);
        setDataModified(true);
    };
    const handledeletePOI = (index) => {
        const updatedreassignMapData = [...reassignMapData.pointsOfInterest];
        updatedreassignMapData.splice(index, 1);

        const updatedPOIPayload = {
            ...reassignMapData,
            recordchange: true,
            [fieldPOIsave]: "",
            userPOIChange: true,
            pointsOfInterest: updatedreassignMapData
        };
        let updatedPOIPayloadNew = updatedPOIPayload;

        // Check if pointsOfInterest array block is empty and delete if its empty
        if (Array.isArray(updatedPOIPayload.pointsOfInterest) &&
            updatedPOIPayload.pointsOfInterest.length === 0) {
            // Create a new object without pointsOfInterest
            const { pointsOfInterest, ...rest } = updatedPOIPayload;
            updatedPOIPayloadNew = rest;
        }
        setSelectedUKey("");
        setReassignMapData(updatedPOIPayloadNew);
        setdeletePOI(true);
        setUserOrPOIchange(true);
        setDataModified(true);
        // setonlyUserChange(false);
        setOnlyPOIChanged(true);
    }
    const setEditorState = (editorState) => {
        setDescription(editorState)
    }

    const handleNote = useCallback((value) => {
        setNote(value);
        setDataModified(true);
    }, []);

    const handleNoteEdit = () => {
        const localNote = noteLocalSave.find((noterecord) => noterecord.UNIQUEID === parseInt(tableUniqueValue));
        if (localNote) {
            setNote(localNote.NOTEVAL);
        }
        else {
            setNote("");
        }
        setEditNote(true);
    }

    const handleNoteView = () => {
        setEditNote(false);
    }


    const handlePOIview = (
        !Array.isArray(reassignMapData?.pointsOfInterest) ? (
            // If pointsOfInterest is not an array, render the Select dropdown for POIs
            <FormControl fullWidth style={{ marginTop: '16px' }}>
                <InputLabel id="user-select-label">Select POI</InputLabel>
                <Select
                    labelId="user-select-label"
                    id="user-select"
                    value={selectedUKey}
                    label="Select POI"
                    onChange={handlePOIUKey}
                >
                    {poiData.map((mapdata) => (
                        <MenuItem key={mapdata.UNKdata} value={mapdata.UNKdata}>
                            {mapdata.UNKdata}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        ) : (
            // Else: If pointsOfInterest is an array, filter POIs by POIASSIGNDATE
            (() => {
                // Filter the points of interest where POIASSIGNDATE is equal to mapVisibilityDate
                const filteredPOIs = reassignMapData.pointsOfInterest.filter(
                    (poi) => poi.POIASSIGNDATE === mapVisibilityDate
                );

                // If filtered data exist, then dont show
                if (filteredPOIs.length === 0) {
                    return (
                        <FormControl fullWidth style={{ marginTop: '16px' }}>
                            <InputLabel id="user-select-label">Select POI</InputLabel>
                            <Select
                                labelId="user-select-label"
                                id="user-select"
                                value={selectedUKey}
                                label="Select POI"
                                onChange={handlePOIUKey}
                            >
                                {poiData.map((poi) => (
                                    <MenuItem key={poi.UNKdata} value={poi.UNKdata}>
                                        {poi.UNKdata}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    );
                }
            })()
        )
    );

    return (
        <div style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
            <TopBar
                dateRange={dateRange}
                onDateChange={setDateRange}
                onVisibilityChange={handleVisibilityChange}
            />
            {(savedata || travelTimeLoader) && <LoadingOverlay />}
            <div style={{ flex: 1, display: 'flex', overflow: 'hidden', position: 'relative', flexGrow: 1 }}>

                <CollapsibleSidebar isOpen={leftSidebarOpen} onToggle={toggleLeftSidebar} side="left">
                    <LeftSidebar
                        isVisible={leftSidebarOpen}
                        dateRange={dateRange}
                        onDateChange={setDateRange}
                        onPOIDataChange={handlePOIDataChange}
                        //onCombinedDataChange={handleCombinedDataChange}
                        setSelectedTraveler={setSelectedTraveler}
                        setSelectedSourceMain={setSelectedSourceMain}
                        setdayCapacityValue={setdayCapacityValue}
                        setmessageFields={setmessageFields}
                        setpopupFields={setpopupFields}
                        setdurationFields={setdurationFields}
                        settableUniqueName={settableUniqueName}
                        setfieldPOIsave={setfieldPOIsave}
                        setstartTimeField={setstartTimeField}
                        setendTimeField={setendTimeField}
                        setfielduserstartTime={setfielduserstartTime}
                        setTskTravelTimeField={setTskTravelTimeField}
                        setfixschedulefield={setfixschedulefield}
                        //setFinalTravelTimeData={setFinalTravelTimeData}
                        mapVisibilityDate={mapVisibilityDate}
                        setSelectedSourceMapname={setSelectedSourceMapname}
                        seteditablefield={seteditablefield}
                        setsubformName={setsubformName}
                        setZDATERANGE={setZDATERANGE}
                        setMainFormName={setMainFormName}
                        // setfielduserHide={setfielduserHide}
                        setParticipantsData={setParticipantsData}
                        setstatuscolorField={setstatuscolorField}
                    />
                </CollapsibleSidebar>
                <div style={{ flex: 1, position: 'relative' }}>
                    <div style={{ ...containerStyle, position: 'absolute', top: 0, left: 0, right: 0, bottom: 0 }}>
                        {viewMode === 'map' && (
                            <LoadScript googleMapsApiKey={apiKey}>
                                {renderGoogleMap()}
                            </LoadScript>
                        )}
                        {viewMode === 'calendar' && (
                            <CalendarView
                                dateRange={dateRange}
                                onTaskMove={handleTaskMove}
                                selectedtraveler={selectedtraveler}
                                ZDATERANGE={ZDATERANGE}
                                messageFields={messageFields}
                                popupFields={popupFields}
                                tableUniqueName={tableUniqueName}
                                fieldPOIsave={fieldPOIsave}
                                durationFields={durationFields}
                                fielduserstartTime={fielduserstartTime}
                                tskTravelTimeField={tskTravelTimeField}
                                finalTravelTimeData={finalTravelTimeData}
                                mapVisibilityDate={mapVisibilityDate}
                                startTimeField={startTimeField}
                                endTimeField={endTimeField}
                                fixschedulefield={fixschedulefield}
                                subformName={subformName}
                                mainFormName={mainFormName}
                                editablefield={editablefield}
                                participantsData={participantsData}
                                mergeparticipantFields={mergeparticipantFields}
                                participantsFields={participantsFields}
                                statuscolorField={statuscolorField}
                                selectedSourceMapname={selectedSourceMapname}
                                // TaskDialog.js paramaters
                                startsave={startsave}
                                messageData={messageData}
                                reassignMapData={reassignMapData}
                                travelerName={travelerName}
                                selectedUKey={selectedUKey}
                                POIExist={POIExist}
                                selectedChooseData={selectedChooseData}
                                deletePOI={deletePOI}
                                note={note}
                                noteData={noteData}
                                editNote={editNote}
                                description={description}
                                noteLocalSave={noteLocalSave}
                                tableUniqueValue={tableUniqueValue}
                                chooseOptions={chooseOptions}
                                dataModified={dataModified}
                                poiData={poiData}
                                handleDlgClose={handleDlgClose}
                                handleUserChange={handleUserChange}
                                handlePOIUKey={handlePOIUKey}
                                handledeletePOI={handledeletePOI}
                                handleDataReassign={handleDataReassign}
                                handleChooseData={handleChooseData}
                                handleNote={handleNote}
                                handleNoteEdit={handleNoteEdit}
                                handleNoteView={handleNoteView}
                                setEditorState={setEditorState}
                                imageUploadCallback={imageUploadCallback}
                                selectedagentindexval={headerIndexval}
                                //PriorityWebSDKService.js paramaters
                                setChooseOptions={setChooseOptions}
                                envFileData={envFileData}
                            />
                        )}
                    </div>
                    <div style={{
                        position: 'absolute',
                        top: '10px',
                        right: '10px',
                        zIndex: 1000,
                        backgroundColor: 'white',
                        padding: '5px',
                        borderRadius: '4px',
                        boxShadow: '0 2px 6px rgba(0,0,0,0.3)'
                    }}>
                        <ToggleButtonGroup
                            size="small"
                            color="primary"
                            value={viewMode}
                            exclusive
                            onChange={handleViewModeChange}
                            aria-label="view mode"
                        >
                            <ToggleButton value="map" aria-label="Map View">
                                Map
                            </ToggleButton>
                            <ToggleButton value="calendar" aria-label="Calendar View">
                                Calendar
                            </ToggleButton>
                        </ToggleButtonGroup>
                        {viewMode === 'map' && (
                            <div style={{ textAlign: 'center' }}>
                                <b>Popups</b>
                                <Switch
                                    checked={switchChecked}
                                    onChange={handleswitchChange}
                                />
                            </div>
                        )}
                    </div>
                </div>
                <div style={{ width: '20%', overflowY: 'auto', background: '#e5e7eb' }}>
                    <RightSidebar
                        // combinedData={combinedData}
                        selectedtraveler={selectedtraveler}
                        selectedSourceMain={selectedSourceMain}
                        // onCombinedDataUpdate={handleCombinedDataUpdate}
                        dayCapacityValue={dayCapacityValue}
                        durationFields={durationFields}
                        messageFields={messageFields}
                        mapVisibilityDate={mapVisibilityDate}
                        ZDATERANGE={ZDATERANGE}
                        tableUniqueName={tableUniqueName}
                        fieldPOIsave={fieldPOIsave}
                        startTimeField={startTimeField}
                        endTimeField={endTimeField}
                        fielduserstartTime={fielduserstartTime}
                        tskTravelTimeField={tskTravelTimeField}
                        fixschedulefield={fixschedulefield}
                        finalTravelTimeData={finalTravelTimeData}
                        // startsave={startsave}
                        selectedSourceMapname={selectedSourceMapname}
                        editablefield={editablefield}
                        subformName={subformName}
                        participantsData={participantsData}
                    />
                    {(editablefield !== "" && selectedSourceMain !== "" && taskClicked) || changeChooseData ?
                        <PriorityWebSDKService setChooseOptions={setChooseOptions}
                            editablefield={editablefield} selectedSourceMain={selectedSourceMain}
                            envFileData={envFileData} tableUniqueName={tableUniqueName}
                            tableUniqueValue={tableUniqueValue} />
                        : <></>}
                </div>
            </div>

            <Dialog open={dlgPOIopen} sx={{ width: '300px' }} PaperProps={{
                sx: {
                    border: `2px solid ${agentColor}`,
                    borderRadius: 2,
                }
            }}>
                <DialogTitle>Assign POI</DialogTitle>
                <DialogContent>
                    {reassignMapData ?
                        <div>
                            <strong style={{ fontSize: '0.9em' }}>{selectedtraveler}: </strong> {reassignMapData[selectedtraveler]}
                        </div>
                        : <></>}
                    {POIExist ?
                        <Table>
                            <TableBody>
                                <TableRow>
                                    <TableCell><b>POI</b></TableCell>
                                    <TableCell><b>DELETE</b></TableCell>
                                </TableRow>
                                {reassignMapData.pointsOfInterest !== undefined
                                    && reassignMapData.pointsOfInterest.map((poi, index) => (
                                        poi.POIASSIGNDATE === mapVisibilityDate ?
                                            <TableRow key={index}>
                                                <TableCell>{poi.UNKdata}</TableCell>
                                                {/* <TableCell><ClearIcon color="error"
                                                onClick={() => handledeletePOI(index)} /></TableCell> */}
                                                <TableCell>
                                                    <button onClick={() => handledeletePOI(index)}
                                                        style={{ cursor: 'pointer', background: 'none', border: 'none' }}
                                                    >
                                                        <ClearIcon fontSize="small" color="error" />
                                                    </button>
                                                </TableCell>
                                            </TableRow>
                                            : <></>
                                    ))}
                            </TableBody>
                        </Table>
                        : <></>}
                    {handlePOIview}
                </DialogContent>
                <DialogActions>
                    {!assignPOI ? (
                        <>
                            <Button onClick={() => handlePOIReassign()} disabled={poiData.length === 0}> {/*|| (selectedUKey === "" && saveType === "")*/}
                                Confirm
                            </Button>
                            <Button onClick={handleDlgPOIClose} disabled={deletePOI}>Cancel</Button>
                        </>
                    ) : (
                        <div>
                            <CircularProgress size={25} />&nbsp;Processing...
                        </div>
                    )}
                </DialogActions>
            </Dialog>
            {taskClicked && selectedTaskVal && (
                <TaskDialog
                    // Dialog states
                    dlgopen={dlgopen}
                    startsave={startsave}
                    // Dialog data
                    messageData={messageData}
                    reassignMapData={reassignMapData}
                    travelerName={travelerName}
                    selectedUKey={selectedUKey}
                    POIExist={POIExist}
                    selectedChooseData={selectedChooseData}
                    deletePOI={deletePOI}
                    note={note}
                    noteData={noteData}
                    editNote={editNote}
                    description={description}
                    noteLocalSave={noteLocalSave}
                    tableUniqueValue={tableUniqueValue}
                    agentColor={agentColor}
                    // Context data
                    combinedData={combinedData}
                    selectedtraveler={selectedtraveler}
                    poiData={poiData}
                    editablefield={editablefield}
                    chooseOptions={chooseOptions}
                    subformName={subformName}
                    dataModified={dataModified}

                    // Event handlers
                    handleDlgClose={handleDlgClose}
                    handleUserChange={handleUserChange}
                    handlePOIUKey={handlePOIUKey}
                    handledeletePOI={handledeletePOI}
                    handleDataReassign={handleDataReassign}
                    handleChooseData={handleChooseData}
                    handleNote={handleNote}
                    handleNoteEdit={handleNoteEdit}
                    handleNoteView={handleNoteView}
                    setEditorState={setEditorState}
                    imageUploadCallback={imageUploadCallback}

                    //input for ParticipantsDialog.js
                    selectedtask={selectedTaskVal}
                    selectedagentindexval={headerIndexval}
                    participantsData={participantsData}
                    tableUniqueName={tableUniqueName}
                    tskTravelTimeField={tskTravelTimeField}
                    mapVisibilityDate={mapVisibilityDate}
                    ZDATERANGE={ZDATERANGE}
                    durationFields={durationFields}
                    fielduserstartTime={fielduserstartTime}
                    startTimeField={startTimeField}
                    endTimeField={endTimeField}
                    fixschedulefield={fixschedulefield}
                    selectedSourceMapname={selectedSourceMapname}
                />)}
            {showPOIDialog && (
                <PoiwarningDialog
                    dlgPoiWarning={showPOIDialog}
                    handlePOIDlgYes={handlePOIDlgYes}
                    handlePOIDlgNo={handlePOIDlgNo}
                />
            )}
            {showHolidayDialog && <HolidayDialog
                dlgHoliday={showHolidayDialog}
                handleHolidayYes={handleHolidayYes} />}

            {showHolidayWrngDialog && <HolidayWrngDialog
                dlgHolidayWrng={showHolidayWrngDialog}
                handleHolidayWrngYes={handleHolidayWrngYes} />}
        </div>
    );
};

export default Mapandtrack;